import React from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/Header";
import WelcomeImage1 from "../../components/WelcomeImage1";
import TextImage from "./TextImage";
import ImageCollage from "./ImageCollage1";
import Cards from "./Cards";
import Footer from "../../components/Footer";
import backgroundImage from "../../assets/images/sponsor/sponsoring11.jpg";

function Sponsoring() {
  const welcomeHeading = <>Sponsoring</>;

  const ImageHeading = <>DePloegOpDeRoot</>;
  const imagetext = (
    <>
      De DD-Group heeft de ambitie om een ​​belangrijke speler te worden binnen
      de Nederlandse en Belgische arbeidsmarkt maar wel op een maatschappelijk
      verantwoorde en gezonde manier. Een belangrijk onderdeel van deze ambitie
      is zichtbaarheid en aanwezigheid op beurzen, sociale media,
      netwerkbijeenkomsten etc. Binnen deze ambitie hebben wij in 2022 een
      geweldige kans gekregen om hoofdsponsor te worden van het Isorex-No Aqua
      Ladies Cycling Team. Na het eerste jaar zijn de ambities versterkt met een
      uitbreiding van de ploeg en versterking van de financiële basis door
      vergroting van het aantal sponsors. <br />
      Eind 2024 heeft de ploeg een UCI continental licentie gekregen wat verdere
      professionalisering betekende voor het team. Met het Clubteam en UCI-team
      zijn afgelopen jaar al meerdere successen behaald. <br />
      ONZE AMBITIES VOOR 2026 - 2028: EEN NIEUWE STAP VOORWAARTS Voor het
      seizoen 2026 wordt een derde team toegevoegd aan “DePloegOpDeRoot”. De
      organisatie wordt uitgebreid met een team onder de 19 (U-19). Toptalenten
      uit België en Nederland gaan deel uitmaken van onze gezamenlijke ambitie.
      Door de toevoeging van het U-19 team wordt een sterk intern
      opleidingstraject gecreëerd richting het UCI continental team. <br />
      Bezoek deze URL voor meer informatie en nieuws over ons team: <br />
      <a
        href="https://deploegopderoot.be/"
        target="_blank"
        rel="noreferrer"
        className="text-white"
      >
        https://deploegopderoot.be/
      </a>
    </>
  );
  return (
    <div>
      <Helmet>
        <title>Sponsoring</title>
        <meta
          name="description"
          content="Krijg training met DD-Group over veiligheid, brandpreventie en cybersecurity via Play-IT. Voor interne transport- en veiligheidstrainingen kun je contact met ons opnemen, en wij verbinden je met 'The Knowledge' voor het beste aanbod via onze speciale referentie."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage1
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <TextImage heading={ImageHeading} text={imagetext} />
          <Cards />
          <ImageCollage />
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default Sponsoring;
